import { motion } from "framer-motion";
import type { Variants } from "framer-motion";
import React from "react";


export const forwardVariants: Variants = {
  initial: {
    x: "100%",
    opacity: 0,
  },
  in: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.3,
      ease: "easeInOut",
    },
  },
  exit: {
    x: "-100%",
    opacity: 0,
    transition: {
      duration: 0.3,
      ease: "easeInOut",
    },
  },
};

export const backwardVariants: Variants = {
  initial: {
    x: "-100%",
    opacity: 0,
  },
  in: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.3,
      ease: "easeInOut",
    },
  },
  exit: {
    x: "100%",
    opacity: 0,
    transition: {
      duration: 0.3,
      ease: "easeInOut",
    },
  },
};

// Component to wrap pages with animations
interface AnimatedPageProps {
  children: React.ReactNode;
  backward?: boolean;
}

const AnimatedPage = ({ children, backward = false }: AnimatedPageProps) => {
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="exit"
      variants={backward ? backwardVariants : forwardVariants}
      style={{ 
        backgroundColor: "#000513",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
      className="w-full h-full"
    >
      {children}
    </motion.div>
  );
};

export default AnimatedPage;
